import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import da from '@/i18n/locales/da.json';
import en from '@/i18n/locales/en.json';

/** Only written when the clinician picks a language in Account & security. */
export const UI_LANG_STORAGE_KEY = 'clinio-v2-ui-lang';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      da: { translation: da },
      en: { translation: en },
    },
    fallbackLng: 'da',
    supportedLngs: ['da', 'en'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Browser language is ignored. Danish is used until the user stores a choice.
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: UI_LANG_STORAGE_KEY,
    },
  });

export function uiLocale(): 'da' | 'en' {
  const lang = (i18n.resolvedLanguage ?? i18n.language ?? 'da').toLowerCase();
  return lang.startsWith('en') ? 'en' : 'da';
}

export function uiDateLocale(): string {
  return uiLocale() === 'da' ? 'da-DK' : 'en-GB';
}

export default i18n;
